export default {
      id: "services-add-grey-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svgsprite.svg#services-add-grey",
      toString: function () {
        return this.url;
      }
    }